import React from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";

const ErrorPageType: Page = {
  ActiveTab: "Error",
  DisplayName: "Virhe",
  LinkUrl: "/error",
  Path: "/error",
  RouteName: "error",
};

const ErrorPage = () => {
  return (
    <div className={ErrorPageType.RouteName}>
      <Layout CurrentPage={ErrorPageType}>
        <h1>{ErrorPageType.DisplayName}</h1>
      </Layout>
    </div>
  );
};

export default ErrorPage;
